import isPropValid from '@emotion/is-prop-valid';

function filterProps(obj) {
  return Object.keys(obj).filter(function (prop) {
    return isPropValid(prop);
  }).reduce(function (acc, prop) {
    acc[prop] = obj[prop];
    return acc;
  }, {});
}

export default filterProps;
//# sourceMappingURL=filter-invalid-attributes.js.map
